import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';

import { CoreserviceService } from '../coreservice.service';
import { IsoverProvider } from '../data.service';

@Component({
  selector: 'app-modaletech',
  templateUrl: './modaletech.component.html',
  styleUrls: ['./modaletech.component.scss']
})

export class ModaletechComponent implements OnInit {
  config: any;
  idBstep = 0;
  idPiece = 0;
  idStep;
  index;
  product: any;
  products: any;
  swipeIndex: any;
  transform: number;

  @ViewChild('SwiperDirective') directiveRef: SwiperDirective;

  constructor(
    private _router: Router,
    private coreService: CoreserviceService,
    private isoprovider: IsoverProvider,
    private route: ActivatedRoute,
  ) { }

  public onIndexChange(index: number): void {
    this.swipeIndex = index + 1;
  }

  ngOnInit() {
    this.index = 0;
    this.swipeIndex = 1;
    this.transform = 100;
    this.config = {
      pagination: true,
      direction: 'horizontal',
      paginationClickable: true,
      navigation: {
        nextEl: '.next',
        prevEl: '.prev',
      },
      spaceBetween: 30
    };

    this.route.params.subscribe(params => {
      this.idPiece = +params['idPiece']; // (+) converts string 'id' to a number
      this.idStep = +params['idStep'];

      this.coreService.showBackButton.emit({
        isVisible: true,
        url: `/detail/${this.idPiece}/${this.idStep}`
      });

      this.isoprovider.getPieces().subscribe( res => {
        this.products = res;
        this.product = res[this.idPiece];
      });
    });
  }
}
